<template>
<!-- MODAL -->
  <CommonLoading
    v-if="loading"
  />
  <AjusteManualModal 
    v-model:open="ajusteManualOpen" 
    :movimentacao="movimentacaoSelecionada"
    @sucesso="onAjusteSucesso"
  />
  <HistoricoAjusteModal
    v-model:open="historicoOpen"
    :movimentacao="movimentacaoSelecionada"
  />
  <div class="p-6 bg-gray-50 rounded-lg shadow-md">
    <h2 class="text-xl font-semibold text-gray-700 mb-4">Resumo de Dados da Movimentação</h2>
    <!-- Header / Resumo da Movimentação -->
    <div class="rounded-xl border border-gray-200 bg-white shadow-sm p-5">
      <div class="flex items-start justify-between gap-4">
        <div>
          <h2 class="text-lg font-semibold text-gray-900">
            Movimentação — {{ controleData?.apolice || '-' }}
          </h2>
          <p class="text-sm text-gray-500 mt-0.5">
            Empresa: <span class="text-gray-700 font-medium">{{ controleData?.empresa || '-' }}</span>
          </p>
        </div>

        <div class="flex items-center gap-2">
          <button
            v-if="podeEnviarPrevia"
            @click="baixarCsv"
            class="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          >
            Baixar {{ labelTermo }} CSV
          </button>
          <button
            v-if="podeEnviarPrevia"
            @click="enviarEmail"
            class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500"
          >
            Mandar {{ labelTermo }} p/ Empresa
          </button>
          <span
            class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold"
            :class="statusBadgeClass"
          >
            {{ statusLabel }}
          </span>
        </div>
      </div>

      <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <div class="rounded-lg border border-gray-200 p-3">
          <p class="text-xs font-medium text-gray-500">Data geração</p>
          <p class="mt-1 text-sm font-semibold text-gray-900">
            {{ controleData?.data_geracao || '-' }}
          </p>
        </div>

        <div class="rounded-lg border border-gray-200 p-3">
          <p class="text-xs font-medium text-gray-500">Data fechamento</p>
          <p class="mt-1 text-sm font-semibold text-gray-900">
            {{ controleData?.data_fechamento || '—' }}
          </p>
        </div>

        <div class="rounded-lg border border-gray-200 p-3">
          <p class="text-xs font-medium text-gray-500">Vigência</p>
          <p class="mt-1 text-sm font-semibold text-gray-900">
            {{ controleData?.vigencia || '-' }}
          </p>
        </div>

        <div class="rounded-lg border border-gray-200 p-3">
          <p class="text-xs font-medium text-gray-500">Qtd. vidas</p>
          <p class="mt-1 text-sm font-semibold text-gray-900">
            {{ controleData?.qtd_vidas ?? 0 }}
          </p>
        </div>
      </div>
    </div>

      <!-- Resumo Financeiro Geral (Caso tenha apenas 1 plano ou queira ver o total) -->
      <div v-if="totaisPorPlano.length <= 1">
        <h3 class="text-base font-semibold text-gray-900">Resumo Financeiro</h3>
        <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
          <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
            <dt class="truncate text-sm font-medium text-gray-500">Capital Anterior</dt>
            <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{{ formatMoeda(dataResumo?.capital_anterior) }}</dd>
          </div>
          <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
            <dt class="truncate text-sm font-medium text-gray-500">Capital Atual</dt>
            <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{{ formatMoeda(dataResumo?.capital_atual) }}</dd>
          </div>
          <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
            <dt class="truncate text-sm font-medium text-gray-500">Premio Anterior</dt>
            <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{{ formatMoeda(dataResumo?.premio_anterior) }}</dd>
          </div>
          <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
            <dt class="truncate text-sm font-medium text-gray-500">Premio Atual</dt>
            <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{{ formatMoeda(dataResumo?.premio_atual) }}</dd>
          </div>
          <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
            <dt class="truncate text-sm font-medium text-gray-500">Quantidade de Vidas</dt>
            <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{{ dataResumo?.qtd_vidas ?? 0 }}</dd>
          </div>
        </dl>
      </div>

      <!-- Resumo Financeiro por Plano (Caso tenha mais de 1 plano) -->
      <div v-else>
        <h3 class="text-base font-semibold text-gray-900">Resumo por Planos</h3>
        <div class="mt-5 grid grid-cols-1 gap-6 xl:grid-cols-2">
          <div v-for="plano in totaisPorPlano" :key="plano.plano_id" class="rounded-xl border border-indigo-100 bg-white p-5 shadow-sm">
            <h4 class="text-md font-bold text-indigo-700 flex items-center gap-2 mb-4">
              <span class="p-1.5 bg-indigo-50 rounded-lg">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </span>
              {{ plano.plano_nome }}
            </h4>
            
            <div class="grid grid-cols-2 sm:grid-cols-3 gap-4">
              <div class="p-3 bg-gray-50 rounded-lg">
                <p class="text-[10px] font-medium text-gray-500 uppercase tracking-wider">Premio Anterior</p>
                <p class="mt-1 text-lg font-bold text-gray-900">{{ formatMoeda(plano.premio_anterior) }}</p>
              </div>
              <div class="p-3 bg-indigo-50 rounded-lg">
                <p class="text-[10px] font-medium text-indigo-600 uppercase tracking-wider">Premio Atual</p>
                <p class="mt-1 text-lg font-bold text-indigo-800">{{ formatMoeda(plano.premio_atual) }}</p>
              </div>
              <div class="p-3 bg-gray-50 rounded-lg">
                <p class="text-[10px] font-medium text-gray-500 uppercase tracking-wider">Capital Anterior</p>
                <p class="mt-1 text-lg font-bold text-gray-900">{{ formatMoeda(plano.capital_anterior) }}</p>
              </div>
              <div class="p-3 bg-gray-50 rounded-lg">
                <p class="text-[10px] font-medium text-gray-500 uppercase tracking-wider">Capital Atual</p>
                <p class="mt-1 text-lg font-bold text-gray-900">{{ formatMoeda(plano.capital_atual) }}</p>
              </div>
              <div class="p-3 bg-gray-50 rounded-lg">
                <p class="text-[10px] font-medium text-gray-500 uppercase tracking-wider">Vidas</p>
                <p class="mt-1 text-lg font-bold text-gray-900">{{ plano.qtd_vidas }}</p>
              </div>
            </div>

            <!-- Mini Resumo de Eventos por Plano -->
            <div class="mt-6 border-t border-gray-100 pt-4">
              <p class="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3">Eventos do Plano</p>
              <div class="grid grid-cols-3 gap-2">
                <div class="flex flex-col items-center p-2 bg-gray-50 rounded-md">
                  <span class="text-[9px] text-gray-500 uppercase">Inc.</span>
                  <span class="text-sm font-bold text-gray-700">{{ plano.eventos?.inclusao ?? 0 }}</span>
                </div>
                <div class="flex flex-col items-center p-2 bg-gray-50 rounded-md">
                  <span class="text-[9px] text-gray-500 uppercase">Canc.</span>
                  <span class="text-sm font-bold text-red-600">{{ plano.eventos?.cancelamento ?? 0 }}</span>
                </div>
                <div class="flex flex-col items-center p-2 bg-gray-50 rounded-md">
                  <span class="text-[9px] text-gray-500 uppercase">Reenq.</span>
                  <span class="text-sm font-bold text-gray-700">{{ plano.eventos?.reenquadramento ?? 0 }}</span>
                </div>
                <div class="flex flex-col items-center p-2 bg-blue-50 rounded-md">
                  <span class="text-[9px] text-blue-500 uppercase">IPCA</span>
                  <span class="text-sm font-bold text-blue-700">{{ plano.eventos?.ipca ?? 0 }}</span>
                </div>
                <div class="flex flex-col items-center p-2 bg-gray-50 rounded-md">
                  <span class="text-[9px] text-gray-500 uppercase">Atu.</span>
                  <span class="text-sm font-bold text-gray-700">{{ plano.eventos?.atualizacao ?? 0 }}</span>
                </div>
                <div class="flex flex-col items-center p-2 bg-gray-50 rounded-md">
                  <span class="text-[9px] text-gray-500 uppercase">S/Alt</span>
                  <span class="text-sm font-bold text-gray-500">{{ plano.eventos?.sem_alteracao ?? 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Eventos -->
        <div class="mt-6">
          <h3 class="text-base font-semibold text-gray-900">Resumo de Eventos</h3>

          <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-4 lg:grid-cols-7">
            <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
              <dt class="truncate text-sm font-medium text-gray-500">Inclusão</dt>
              <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
                {{ dataEventos?.inclusao ?? 0 }}
              </dd>
            </div>

            <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
              <dt class="truncate text-sm font-medium text-gray-500">Atualização</dt>
              <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
                {{ dataEventos?.atualizacao ?? 0 }}
              </dd>
            </div>

            <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
              <dt class="truncate text-sm font-medium text-gray-500">Reenquadramento</dt>
              <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
                {{ dataEventos?.reenquadramento ?? 0 }}
              </dd>
            </div>

            <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
              <dt class="truncate text-sm font-medium text-gray-500">IPCA</dt>
              <dd class="mt-1 text-3xl font-semibold tracking-tight text-blue-600">
                {{ dataEventos?.ipca ?? 0 }}
              </dd>
            </div>

            <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
              <dt class="truncate text-sm font-medium text-gray-500">Reenq. + IPCA</dt>
              <dd class="mt-1 text-3xl font-semibold tracking-tight text-indigo-600">
                {{ dataEventos?.reenquadramento_ipca ?? 0 }}
              </dd>
            </div>

            <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
              <dt class="truncate text-sm font-medium text-gray-500">Cancelamento</dt>
              <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
                {{ dataEventos?.cancelamento ?? 0 }}
              </dd>
            </div>

            <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
              <dt class="truncate text-sm font-medium text-gray-500">Sem Alteração</dt>
              <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
                {{ dataEventos?.sem_alteracao ?? 0 }}
              </dd>
            </div>
          </dl>
        </div>

    <!-- Segurados Cancelados -->
    <div v-if="cancelamentosDetalhes.length > 0" class="mt-8 flow-root">
      <div class="-mx-4 -my-2 overflow-x-auto relative sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <h3 class="text-base font-semibold text-red-600 mb-2">Segurados Cancelados no Período</h3>
          <table class="min-w-full divide-y divide-gray-300">
            <thead>
              <tr>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Segurado</th>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Data de Cancelamento</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
              <tr v-for="c in cancelamentosDetalhes" :key="c.segurado_nome" class="hover:bg-red-50">
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">{{ c.segurado_nome }}</td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">{{ c.data_cancelamento }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="mt-8 flow-root">
      <div class="-mx-4 -my-2 overflow-x-auto relative sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <h2> Lançamentos </h2>
          <table class="min-w-full divide-y divide-gray-300">
            <thead>
                <tr>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Plano
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Segurado
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Evento
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Data reenquadramento
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Data último IPCA
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Cap. Anterior
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Cap. Novo
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Mensal Ant.
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Mensal Novo
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Prêmio Ant.
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Prêmio Novo
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    % reajuste
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Idade
                  </th>
                  <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Observação
                  </th>

                  <!-- Ações -->
                  <th scope="col" class="sticky acao-coluna-cabecalho whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                    <span class="sr-only">Ações</span>
                  </th>
                </tr>
              </thead>  

              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="row in movData" :key="row.segurado_nome" class="hover:bg-gray-100">
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ row.plano_nome ?? '-' }}
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ row.segurado_nome }}
                  </td>

                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 uppercase font-bold">
                    {{ row.tipo_evento ?? '-' }}
                  </td>

                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ row.data_reenquadramento ?? '-' }}
                  </td>

                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ row.data_ultimo_ipca ?? '-' }}
                  </td>

                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ formatMoeda(row.valor_capital_anterior) }}
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ formatMoeda(row.valor_capital_novo) }}
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ formatMoeda(row.valor_mensal_anterior) }}
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ formatMoeda(row.valor_mensal_novo) }}
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ formatMoeda(row.valor_premio_anterior) }}
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ formatMoeda(row.valor_premio_novo) }}
                  </td>
                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ row.percentual_reajuste ?? '-' }}
                  </td>

                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    {{ row.idade ?? '-' }}
                  </td>

                  <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                    <div class="flex items-center gap-2">
                      {{ row.observacao || '-' }}
                      <span 
                        v-if="row.tem_ajuste" 
                        @click="abrirHistorico(row)"
                        class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 cursor-pointer hover:bg-blue-100"
                        title="Ver histórico de ajustes"
                      >
                        Ajustado ℹ️
                      </span>
                    </div>
                  </td>

                  <!-- Ações -->
                  <td class="whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                    <button 
                      @click="abrirAjusteManual(row)"
                      class="text-amber-600 hover:text-amber-900 bg-amber-50 px-2 py-1 rounded transition-colors"
                      title="Ajuste Manual"
                    >
                      Ajustar
                    </button>
                    <button 
                      v-if="row.tem_ajuste"
                      @click="abrirHistorico(row)"
                      class="ml-2 text-blue-600 hover:text-blue-900 bg-blue-50 px-2 py-1 rounded transition-colors"
                      title="Ver Histórico"
                    >
                      Ver Log
                    </button>
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
      </div>
      <div class="flex justify-between items-center mt-2.5 space-x-4">
        <div class="flex items-center">
          <span class="text-sm text-gray-600">Página {{ currentPageMov }} de {{ totalPagesMov }} | Total de registros: {{ totalRecordsMov }}</span>
        </div>
        <div class="flex sticky items-center space-x-2">
          <button @click="paginate('movimentacao','previous')" v-if="previousMov" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Anterior</button>
          <button @click="paginate('movimentacao','next')" v-if="nextMov" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Próximo</button>
          <input type="number" v-model="pageNumberMov" min="1" :max="totalPagesMov" class="border border-gray-300 rounded-md px-2 py-1 text-sm" placeholder="Ir para..." />
          <button @click="goToPage('mov')" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Ir</button>
        </div>
      </div>
    </div>

    <div class="mt-8 flow-root">
      <div class="-mx-4 -my-2 overflow-x-auto relative sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <h2> Eventos </h2>
          <table class="min-w-full divide-y divide-gray-300">
            <thead>
              <tr>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                  #
                </th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Plano
                </th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Segurado
                </th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Tipo evento
                </th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Aplicou IPCA
                </th>

                <!-- (opcional) ações -->
                <th scope="col" class="sticky acao-coluna-cabecalho whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                  <span class="sr-only">Ações</span>
                </th>
              </tr>
            </thead>

            <tbody class="divide-y divide-gray-200 bg-white">
              <tr
                v-for="row in resumoEventos"
                :key="row.evento_id"
                class="hover:bg-gray-100"
              >
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                  #{{ row.evento_id }}
                </td>

                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                  {{ row.plano_nome ?? '-' }}
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                  {{ row.segurado_nome ?? '-' }}
                </td>

                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                  {{ row.tipo_evento ?? '-' }}
                </td>

                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                  {{ row.aplicou_ipca ? 'Sim' : 'Não' }}
                </td>

                <!-- ações (se não usar, pode remover a coluna toda) -->
                <td class="whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  <!-- exemplo: <button class="text-indigo-600 hover:text-indigo-900">Ver</button> -->
                </td>
              </tr>

              <tr v-if="!resumoEventos || resumoEventos.length === 0">
                <td colspan="5" class="px-4 py-6 text-sm text-gray-500 text-center">
                  Nenhum evento encontrado.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
         
      </div>
       <div class="flex justify-between items-center mt-2.5 space-x-4">
          <div class="flex items-center">
            <span class="text-sm text-gray-600">Página {{ currentPageEventos }} de {{ totalPagesEventos }} | Total de registros: {{ totalRecordsEventos }}</span>
          </div>
          <div class="flex sticky items-center space-x-2">
            <button @click="paginate('eventos','previous')" v-if="previousEventos" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Anterior</button>
            <button @click="paginate('eventos','next')" v-if="nextEventos" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Próximo</button>
            <input type="number" v-model="pageNumberEventos" min="1" :max="totalPagesEventos" class="border border-gray-300 rounded-md px-2 py-1 text-sm" placeholder="Ir para..." />
            <button @click="goToPageEventos" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Ir</button>
          </div>
        </div>
    </div>

    <!-- Regras Aplicadas -->
    <div class="mt-8 flow-root">
      <div class="-mx-4 -my-2 overflow-x-auto relative sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <h2> Regras Aplicadas </h2>
          <table class="min-w-full divide-y divide-gray-300">
            <thead>
              <tr>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Plano
                </th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Segurado
                </th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Regra
                </th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Valor Anterior
                </th>
                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Valor Novo
                </th>
              </tr>
            </thead>

            <tbody class="divide-y divide-gray-200 bg-white">
              <tr
                v-for="row in regrasAplicadas"
                :key="row.id"
                class="hover:bg-gray-100"
              >
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                  {{ row.plano_nome ?? '-' }}
                </td>
                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                  {{ row.segurado?.nome ?? '-' }}
                </td>

                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                  {{ row.regra_nome }} {{ row.regra?.tipo ? '(' + row.regra.tipo + ')' : '' }}
                </td>

                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                  {{ row.valor_anterior ?? '-' }}
                </td>

                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                  {{ row.valor_novo ?? '-' }}
                </td>
              </tr>

              <tr v-if="!regrasAplicadas || regrasAplicadas.length === 0">
                <td colspan="4" class="px-4 py-6 text-sm text-gray-500 text-center">
                  Nenhuma regra aplicada encontrada.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="flex justify-between items-center mt-2.5 space-x-4">
        <div class="flex items-center">
          <span class="text-sm text-gray-600">Página {{ currentPageRegras }} de {{ totalPagesRegras }} | Total de registros: {{ totalRecordsRegras }}</span>
        </div>
        <div class="flex sticky items-center space-x-2">
          <button @click="paginate('regras','previous')" v-if="previousRegras" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Anterior</button>
          <button @click="paginate('regras','next')" v-if="nextRegras" type="button" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Próximo</button>
          <input type="number" v-model="pageNumberRegras" min="1" :max="totalPagesRegras" class="border border-gray-300 rounded-md px-2 py-1 text-sm" placeholder="Ir para..." />
          <button @click="goToPageRegras" class="flex-shrink rounded-md bg-customPurple px-2 py-1 text-center text-sm font-semibold text-white shadow-sm hover:bg-sienaBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Ir</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import { pageVariables } from '@/views/insideviews/movimentacao/PageVariablesMovimentacao';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';
import ControleMovimentosRepository from '@/services/ControleMovimentosRepository.vue';
import AjusteManualModal from '@/components/generalcomponents/AjusteManualModal.vue';
import HistoricoAjusteModal from '@/components/generalcomponents/HistoricoAjusteModal.vue';
import Swal from 'sweetalert2';

  export default {
      name: 'MovimentacaoCommonView',
      data() {
        return {
          ...pageVariables,
          dataResumo:[],
          controleData: null,
          movData:[],
          previousMov: '',
          nextMov: '',
          totalPagesMov: 0,
          totalRecordsMov: 0,
          currentPageMov: 0,
          dataEventos:{},
          resumoEventos:[],
          previousEventos: '',
          nextEventos: '',
          totalPagesEventos: 0,
          totalRecordsEventos: 0,
          currentPageEventos: 0,
          pageNumberEventos:0,
          pageNumberMov:0,
          regrasAplicadas:[],
          previousRegras: '',
          nextRegras: '',
          totalPagesRegras: 0,
          totalRecordsRegras: 0,
          currentPageRegras: 0,
          pageNumberRegras:0,
          cancelamentosDetalhes: [],
          loading: false,
          totaisPorPlano: [],
          onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
          ajusteManualOpen: false,
          historicoOpen: false,
          movimentacaoSelecionada: null
        };
      },
      props: {
      },
      methods:{
        async pageData(page){
          this.loading = true; 
          const controleRepo = new ControleMovimentosRepository();
          try {
            const response = await controleRepo.getControleResumo(page,this.onlineUser.token,this.controleData.id);
            if (response?.status  === 200) {
              this.dataResumo = response.data.totais;
              this.dataEventos = response.data.eventos;
              this.totaisPorPlano = response.data.totais_por_plano || [];
              this.cancelamentosDetalhes = response.data.cancelamentos_detalhes || [];
              this.loading = false;

            }
          } catch (error) {
            this.loading = false;
            this.mostrarAlertaErro(error);
            handleUnauthorized(error); 
          }
        },

        async getMovimentacaoData(page){
          this.loading = true; 
          const controleRepo = new ControleMovimentosRepository();
          try {
            const response = await controleRepo.getControleMovimentacao(page,this.onlineUser.token,this.controleData.id);
            if (response?.status  === 200) {
              this.movData = response.data.data;
              this.loading = false;
              this.totalPagesMov = response.data.last_page;
              this.totalRecordsMov = response.data.total;
              this.currentPageMov = response.data.current_page;

              if (response.data.next_page_url) {
                this.nextMov = response.data.next_page_url;
              }else{
                this.nextMov = ""
              }
              if (response.data.prev_page_url) {
                this.previousMov = response.data.prev_page_url;
              }else{
                this.previousMov = ""
              }
              this.loading = false; 

            }
          } catch (error) {
            this.loading = false;
            this.mostrarAlertaErro(error);
            handleUnauthorized(error); 
          }
        },

        async getEventos(page){
          this.loading = true; 
          const controleRepo = new ControleMovimentosRepository();
          try {
            const response = await controleRepo.getEventos(page,this.onlineUser.token,this.controleData.id);
            if (response?.status  === 200) {
              this.resumoEventos = response.data.data;
              this.loading = false;
              this.totalPagesEventos = response.data.last_page;
              this.totalRecordsEventos = response.data.total;
              this.currentPageEventos = response.data.current_page;

              if (response.data.next_page_url) {
                this.nextEventos = response.data.next_page_url;
              }else{
                this.nextEventos = ""
              }
              if (response.data.prev_page_url) {

                this.previousEventos = response.data.prev_page_url;
              }else{
                this.previousEventos = ""
              }
              this.loading = false; 

            }
          } catch (error) {
            this.loading = false;
            this.mostrarAlertaErro(error);
            handleUnauthorized(error); 
          }
        },

        async getRegrasAplicadas(page){
          this.loading = true; 
          const controleRepo = new ControleMovimentosRepository();
          try {
            const response = await controleRepo.getRegrasAplicadas(page,this.onlineUser.token,this.controleData.id);
            if (response?.status === 200) {
              this.regrasAplicadas = response.data.data;
              this.totalPagesRegras = response.data.last_page;
              this.totalRecordsRegras = response.data.total;
              this.currentPageRegras = response.data.current_page;
              this.nextRegras = response.data.next_page_url || '';
              this.previousRegras = response.data.prev_page_url || '';
              this.loading = false; 
            }
          } catch (error) {
            this.loading = false;
            this.mostrarAlertaErro(error);
            handleUnauthorized(error); 
          }
        },

        goToPageRegras() {
          const targetPage = parseInt(this.pageNumberRegras);
          if (!targetPage || targetPage < 1 || targetPage > this.totalPagesRegras) return;
          const url = `${this.regrasPage}/${this.controleData.id}/regras-aplicadas?page=${targetPage}`;
          this.getRegrasAplicadas(url);
        },

         async paginate(tipo, direction) {
          const isNext = direction === 'next';

          if (tipo === 'eventos') {
            const page = isNext ? this.nextEventos : this.previousEventos;
            if (!page) return;
            return this.getEventos(page);
          }

          if (tipo === 'movimentacao') {
            const page = isNext ? this.nextMov : this.previousMov;
            if (!page) return;
            return this.getMovimentacaoData(page);
          }

          if (tipo === 'regras') {
            const page = isNext ? this.nextRegras : this.previousRegras;
            if (!page) return;
            return this.getRegrasAplicadas(page);
          }
        },

        async baixarCsv() {
          this.loading = true;
          try {
            const controleRepo = new ControleMovimentosRepository();
            const response = await controleRepo.baixarPreviaCsv(this.onlineUser.token, this.controleData.id);
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const term = this.labelTermo.toLowerCase();
            link.setAttribute('download', `${term}_movimentacao_${this.controleData.id}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            this.loading = false;
          } catch (error) {
            this.loading = false;
            this.mostrarAlertaErro(error);
          }
        },
        async enviarEmail() {
          const { isConfirmed } = await Swal.fire({
            title: 'Confirmar envio?',
            text: `Deseja enviar a ${this.labelTermo.toLowerCase()} da movimentação para a empresa?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, enviar!',
            cancelButtonText: 'Cancelar'
          });

          if (isConfirmed) {
            this.loading = true;
            try {
              const controleRepo = new ControleMovimentosRepository();
              const response = await controleRepo.enviarPreviaEmail(this.onlineUser.token, this.controleData.id);
              if (response.status === 200) {
                Swal.fire('Sucesso!', 'E-mail enviado para fila de processamento.', 'success');
              }
              this.loading = false;
            } catch (error) {
              this.loading = false;
              this.mostrarAlertaErro(error);
            }
          }
        },

        formatMoeda(valor) {
          if (!valor && valor !== 0) return 'R$ 0,00';
          return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(valor);
        },

        abrirAjusteManual(mov) {
          this.movimentacaoSelecionada = mov;
          this.ajusteManualOpen = true;
        },
        abrirHistorico(mov) {
          this.movimentacaoSelecionada = mov;
          this.historicoOpen = true;
        },

        onAjusteSucesso() {
          // Recarrega todos os dados para garantir consistência
          this.pageData(this.resumoPage);
          this.getMovimentacaoData(this.movimentacaoControle);
        }

      },

      mostrarAlertaErro(error) {
        const msg = error?.response?.data?.message || error?.message || 'Ocorreu um erro inesperado.';
        Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: msg,
          confirmButtonColor: '#3085d6',
        });
      },

      components:{
        CommonLoading,
        AjusteManualModal,
        HistoricoAjusteModal
      },
      computed: {
        podeEnviarPrevia() {
          const s = (this.controleData?.situacao || '').toLowerCase();
          return s === 'previa' || s === 'aberta' || s === 'vencido' || s === 'fechada';
        },
        isAdmin() {
          const user = JSON.parse(window.localStorage.getItem("myUser") || "{}");
          const grupos = user.groups || user.auth?.groups || [];
          const masterUsers = ['master.justech', 'gcp-organization-admins', 'vida'];
          return grupos.some(g => masterUsers.includes(g));
        },
        labelTermo() {
          const s = (this.controleData?.situacao || '').toLowerCase();
          return s === 'fechada' ? 'Movimentação' : 'Prévia';
        },
        statusLabel() {
          const s = (this.controleData?.situacao || '').toLowerCase();
          if (!s) return '—';
          if (s === 'previa') return 'Prévia';
          if (s === 'aberta') return 'Aberta';      
          if (s === 'fechada') return 'Fechada';
          return this.controleData?.situacao;
        },
        controleId() {
          return this.$route.params.id
        },
        statusBadgeClass() {
          const s = (this.controleData?.situacao || '').toLowerCase();

          if (s === 'fechada') {
            return 'bg-green-100 text-green-800 ring-1 ring-inset ring-green-200';
          }
          if (s === 'previa') {
            return 'bg-amber-100 text-amber-800 ring-1 ring-inset ring-amber-200';
          }
          if (s === 'aberta') {
            return 'bg-blue-100 text-blue-800 ring-1 ring-inset ring-blue-200';
          }

          return 'bg-gray-100 text-gray-800 ring-1 ring-inset ring-gray-200';
        }
      },
      async mounted() {
        if (this.controleData?.id) {
          this.pageData(this.resumoPage);
          this.getMovimentacaoData(this.movimentacaoControle);
          this.getEventos(this.eventosPage);
        }
         const fromState =
          window.history.state?.usr?.controleData ||
          window.history.state?.controleData

        if (fromState) {
          this.controleData = fromState
          console.log('FILHO controleData:', this.controleData)
          // NÃO dá return aqui, deixa seguir ou deixa o watcher fazer
        }

        // Se não veio do state, ainda dá pra usar a rota
        // (se quiser fallback sem refazer chamada grande, pelo menos tem o id)
        if (!this.controleData?.id && this.controleId) {
          this.controleData = { id: this.controleId }
        }
      },

      watch: {
        'controleData.id': {
          immediate: true, // chama já na inicialização
          handler(newId) {
            if (!newId) return;
            this.pageData(this.resumoPage);
            this.getMovimentacaoData(this.movimentacaoControle);
            this.getEventos(this.eventosPage);
            this.getRegrasAplicadas(this.regrasPage);
          }
        }
      },
  }
</script>
  
  